"use client";

import React, { useState } from "react";
import "./ProcessService.scss";
import { Link } from "react-router-dom";

import { ReactComponent as SideBtnBlack } from "../../assets/svg/side-btn-black.svg";
import { ReactComponent as OfferSvg1 } from "../../assets/svg/offer-svg-1.svg";
import { ReactComponent as OfferSvg2 } from "../../assets/svg/offer-svg-2.svg";
import { ReactComponent as OfferSvg3 } from "../../assets/svg/offer-svg-3.svg";
import { ReactComponent as ArrUpp } from "../../assets/svg/ArrUp.svg";
import { ReactComponent as ArrDown } from "../../assets/svg/Arr-down.svg";

import { SkillData } from "../../data/data";

const ProcessService = () => {
  const [showAnswers, setShowAnswers] = useState(
    Array(SkillData.length).fill(false)
  );

  const toggleAnswer = (index) => {
    setShowAnswers((prevShowAnswers) => {
      const newShowAnswers = prevShowAnswers.map((value, idx) => {
        return idx === index ? !value : false;
      });
      return newShowAnswers;
    });
  };

  return (
    <>
      <section className="processService__banner">
        <article className="processService__banner--container container">
          <div className="processService__banner--container-left">
            <h3>
              Your <span>Vision</span>
            </h3>
            <h3>
              Our <span>Process</span>
            </h3>
            <h3>
              Stellar <span>Result!</span>
            </h3>
          </div>

          <div className="processService__banner--container-right">
            <p>
              At Radiksez, your vision is our compass. Through our proven
              process, we navigate challenges, crafting stellar results that
              reflect our commitment to excellence!
            </p>

            <Link href="/contact-us" className="process-contact__btn">
              <button className="contact__btn">
                <span> Contact Us</span>
              </button>
              <SideBtnBlack />
            </Link>
          </div>
        </article>
      </section>

      <section className="processService">
        <article className="processService__container container">
          <div className="processService__container--header">
            <h3 className="processService__title">OUR SERVICES</h3>
          </div>

          <div className="processService__container--contents">
            <div className="processService__container--contents-left">
              <div className="contents-left-item">
                <OfferSvg1 className="offer-svg-1" />
                <li>Design</li>
              </div>
              <div className="contents-left-item">
                <OfferSvg2 className="offer-svg-2" />
                <li>Marketing</li>
              </div>
              <div className="contents-left-item">
                <OfferSvg3 className="offer-svg-3" />
                <li>Development</li>
              </div>
            </div>

            <div className="processService__container--contents-right">
              {SkillData.map((skills, index) => {
                const { id, title, answer } = skills;
                const isOpen = showAnswers[index];
                return (
                  <div className="contents-right-item" key={id}>
                    <div className="contents-right-item-header">
                      <h3 className="open-service">{title}</h3>
                      <button
                        type="button"
                        className={
                          isOpen
                            ? "open-service-btn active-open-btn"
                            : "open-service-btn"
                        }
                        onClick={() => toggleAnswer(index)}
                      >
                        {isOpen ? <ArrUpp /> : <ArrDown />}
                      </button>
                    </div>

                    {/* Show the answer only if showAnswers[index] is true */}
                    {isOpen && (
                      <p className="contents-right-item-text">{answer}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </article>
      </section>
    </>
  );
};

export default ProcessService;
